import React from "react";
import { CtaButton } from "./ui";
import { checkout } from "../data/content";
import { trackMetaEvent } from "../utils/metaPixel";
type Props = {
  label: string;
  className?: string;
};
export function CheckoutButton({
  label,
  className = ""
}: Props) {
  function handleClick() {
    trackMetaEvent("InitiateCheckout", {
      value: Number(checkout.price),
      currency: checkout.currency
    });
  }
  return <CtaButton href={checkout.url} className={className} onClick={handleClick} data-id="element-51" data-mp="1im0grszycb69">
      {label}
    </CtaButton>;
}